"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const views_1 = require("../core/views");
class ContactModule extends views_1.CreateView {
    constructor() {
        super(...arguments);
        this.endpoint = "/api/v1/contact/";
        this.create = (name, email, subject, telephone, message, landing) => {
            return this._create({ name, email, subject, telephone, message, landing });
        };
    }
}
exports.default = ContactModule;
//# sourceMappingURL=contact.js.map